export default __webpack_public_path__ + "images/wolf-and-sheep.png";